import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { applicationPaths } from '../../Models/configurations';
import { ConfirmationFailComponent } from '../../Shared/Components/confirmation-fail/confirmation-fail.component';
import { UnauthorizePageComponent } from '../../Shared/Components/unauthorize-page/unauthorize-page.component';
import { RouteAuthenticationGuard } from './../../guard/route-authentication.guard';
import { CookiePolicyComponent } from './../../Shared/Components/cookie-policy/cookie-policy.component';
import { FifthStepComponent } from './Container/fifth-step/fifth-step.component';
import { FirstStepComponent } from './Container/first-step/first-step.component';
import { FourthStepComponent } from './Container/fourth-step/fourth-step.component';
import { SecondStepComponent } from './Container/second-step/second-step.component';
import { SevenStepComponent } from './Container/seven-step/seven-step.component';
import { SixStepComponent } from './Container/six-step/six-step.component';
import { StartComponent } from './Container/start/start.component';
import { ThirdStepComponent } from './Container/third-step/third-step.component';
import { StepComponent } from './step.component';

const routes: Routes = [
  {
    path: '',
    component: StepComponent,
    children: [
      {
        path: applicationPaths.login,
        component: StartComponent,
        // resolve: { resource: ContentResolver },
        // data: [{ componentName: ComponentName.UnderwritingComponent }],
        canActivate: [RouteAuthenticationGuard]
      },
      {
        path: applicationPaths.first,
        component: FirstStepComponent,
        // resolve: { resource: ContentResolver },
        // data: [{ componentName: ComponentName.UnderwritingComponent }],
        canActivate: [RouteAuthenticationGuard]
      },
      {
        path: applicationPaths.second,
        component: SecondStepComponent,
      },
      {
        path: applicationPaths.third,
        component: ThirdStepComponent,
      },
      {
        path: applicationPaths.fourth,
        component: FourthStepComponent,
      },
      {
        path: applicationPaths.five,
        component: FifthStepComponent,
      },
      {
        path: applicationPaths.six,
        component: SixStepComponent,
      },
      {
        path: applicationPaths.seven,
        component: SevenStepComponent,
        canActivate: [RouteAuthenticationGuard]
      },
      {
        path: applicationPaths.cookiePolicy,
        component: CookiePolicyComponent,
      },
      {
        path: applicationPaths.unauthorize,
        component: UnauthorizePageComponent
      },
      {
        path: applicationPaths.confirmationfail,
        component: ConfirmationFailComponent
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StepRoutingModule { }
